<template>
  <div class="fixed w-full notification-alert top-[150px]">
    <div v-for="alert in alerts" :key="alert.id" name="slide-up">
      <snap-alert :type="alert.type" :border="true" right-link-text="Details" class="mb-2 w-fit my-0 mx-auto">
        <snap-alert-title>{{ alert.message }} </snap-alert-title>
        <snap-alert-description>{{ alert.description }} </snap-alert-description>
      </snap-alert>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { reactive, inject } from "vue";
import { Emitter } from "mitt";
import { Alert } from "@/Services/emitter";

const alerts = reactive<Alert[]>([]);
const emitter: Emitter<{ alert: Alert }> | undefined = inject("emitter");

emitter &&
  emitter.on("alert", ({ message, type, description, interval = 4000 }) => {
    alerts.unshift({
      id: alerts.length,
      message: message,
      type: type || "success",
      description: description,
    });
    setTimeout(() => {
      alerts.length && alerts.pop();
    }, interval);
  });
</script>
<style>
.notification-alert {
  z-index: 999999;
  top: 10px;
}
.slide-up-enter-active,
.slide-up-leave-active {
  transition: all 0.25s ease-out;
}
.slide-up-enter-from {
  opacity: 0;
  transform: translateY(30px);
}
.slide-up-leave-to {
  opacity: 0;
  transform: translateY(-30px);
}
</style>
